export default {
  ReadByWork: function(action, self, onsuccess, onfailed) {
    return {
        data : {
          query: self.props.work.alias,
          AuthorizationToken : self.props.UserReducer.token,
        },
        action: action,
        self : self,
        onsuccess : self.onReadSuccess,
        onfailed : self.onReadFailed,
    }
  },
  Register: function(self, onsuccess, onfailed) {
    return {
        data : {
          field: {
            Time   : self.state.time_UTC,
            Method : self.state.method,
            Email  : self.state.email,
            Mobile : self.state.mobile,
            Work   : self.state.work,
          },
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : self.onRegisterSuccess,
        onfailed : self.onRegisterFailed,
    }
  },
  Update: function(self, onsuccess, onfailed) {
    return {
        data : {
          field: {
            Time   : self.state.time_UTC,
            Method : self.state.method,
            Email  : self.state.email,
            Mobile : self.state.mobile,
          },
          alias   : self.state.aliasReminder,
          AuthorizationToken : self.props.UserReducer.token,
        },
        self : self,
        onsuccess : self.onUpdateSuccess,
        onfailed : self.onUpdateFailed,
    }
  },
}


// WEBPACK FOOTER //
// ./src/App/remainder/helper/request.props.js